import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileService } from '../../../services/file.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DinamicData, Cell } from '../../../models/dinamic-data';
import swal from "sweetalert2";
import { Methods } from '../../methods';
import { WeightItemService } from '../../../services/weightitem.service';
declare const $: any;
import 'jquery.qrcode/jquery.qrcode.min.js';

@Component({
  selector: 'app-containerphotos',
  templateUrl: './containerphotos.component.html',
  styleUrls: ['./containerphotos.component.css'],
  providers: [ FileService, WeightItemService ]
})
export class ContainerphotosComponent implements OnInit, AfterViewInit {

  public mtds: Methods = new Methods();
  public loading = false;
  public loadingContainer = false;
  public photos: Array<any> = [];
  public urlLandingPage;
  public identity;

  public container = null;

  public listPhotos: DinamicData = new DinamicData();

  constructor(
    private _router: Router,
    public _fileService: FileService,
    public dialogRef: MatDialogRef<ContainerphotosComponent>,
    private _serviceWeigth: WeightItemService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    this.identity = JSON.parse(localStorage.getItem('identity'));
    this.urlLandingPage = `https://www.itaderp.com/backend/reports/upload-images.php?idcontainer=${data.container_id}&u=${this.identity.sub}`;
  }

  ngOnInit() {
    this.detail();
  }

  detail() {
    this.loadingContainer = true;
    this._serviceWeigth.getItem(JSON.parse(localStorage.getItem('token')), this.data.container_id).subscribe(
      (response) => {
        if (
          response.code === 400 &&
          response.msg === "Authorization not valid"
        ) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else if (response.status === "success") {
          console.log(response);
          this.container = response.data;
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        this.loadingContainer = false;
        this.getPhotos();
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.loadingContainer = false;
      }
    );
  }

  locationName(loc) {
    return `${loc.locationName} ${loc.locationRow}-${loc.locationBay}-${loc.locationLevel}-${loc.locationSection}`;
  }

  printlabel() {
    if (this.container.enableAsAVirtualContainer) {
      window.open("https://www.itaderp.com/backend/reports/virtual-container.php?idweight=" + this.data.container_id + "&apikey=" + this.identity.apiCompany);
    } else {
      window.open("https://www.itaderp.com/backend/reports/weight-labels.php?idweight=" + this.data.container_id + "&apikey=" + this.identity.apiCompany);
    }
  }

  getPhotos() {
    this.loading = true;
    this._fileService.getContainerPhotos(this.data.container_id).subscribe(
      (r) => {
        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status === 'success' && r.code === 200) {

          this.photos = r.data || [];

          this.listPhotos.headers = [
            'Id',
            'File',
            // 'Folder',
            'Created At',
            'User',
            'Actions'
          ]

          this.listPhotos.rows = [];

          for (const element of r.data) {

            let actionButtons = [
              { icon: 'remove_red_eye', action: 'Detail', color: 'info', value: `https://itaderp.com/script-upload/${element.folder}/${element.file}` }
            ];

            if (element.user.id === this.identity.sub || this.identity.role === 'ADMINISTRATOR') {
              actionButtons.push({ icon: 'delete_outline', action: 'Remove', color: 'danger', value: element.id });
            }
            this.listPhotos.rows.push (
              [
                new Cell(element.id),
                new Cell(element.file),
                // new Cell(element.folder),
                new Cell(
                  element.createdAt != null
                    ? this.mtds.getFecha(
                        new Date(element.createdAt.timestamp * 1000),
                        "MM/dd/yyyy h:mm:ss"
                      )
                    : null, { type: 'full-date' }
                ),
                new Cell(element.user ? element.user.name + ' ' + element.user.surname : ''),
                new Cell(actionButtons, {type: 'actions'})
              ]
            );
          }

          this.container.numPhotos = this.listPhotos.rows.length;

        } else {
          // this.mtds.notifyError(r.msg, r.code);
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  action(e) {
    console.log(e);
    switch (e.action) {
      case 'Detail':
        window.open(e.id, "_blank");
        break;
      case 'Remove':
        swal.fire({
          title: "Are you sure to remove this file?",
          text: "",
         
          showCancelButton: true,
          buttonsStyling: false,
         customClass:{
    confirmButton: 'btn btn-danger',
    cancelButton: 'btn btn-default',
            },
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Continue",
        }).then(
          function (result) {
            if (result.value) {
              this.delete(e.id);
            }
          }.bind(this)
        );
        break;
      default:
        break;
    }
  }

  delete(id) {
    this._fileService.deleteFile(JSON.parse(localStorage.getItem('token')), id).subscribe(
      (response) => {
        if (response.status == "success") {
          swal.fire({
      
            title: "File has been deleted!",
            text: "",
            buttonsStyling: false,
            customClass:{
    confirmButton: 'btn btn-success'
            },
          });
          this.getPhotos();
        } else {
          alert("Error");
        }
      },
      (error) => {
        console.log(<any>error);
        alert("Error");
      }
    );
  }

  onNoClick() {
    this.dialogRef.close();
  }

  downloadImage(data, filename = 'untitled.jpeg') {
    var a = document.createElement('a');
    a.href = data;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
  }

  putImage() {
    var canvas = document.getElementsByTagName("canvas");
    console.log(canvas);
    var image = canvas[0].toDataURL("image/png").replace("image/png", "image/octet-stream");  // here is the most important part because if you dont replace you will get a DOM 18 exception.

    this.downloadImage(image, "qr-code.png");
    //window.location.href=image; // it will save locally
  }

  ngAfterViewInit() {

    ($("#qrcode") as any).qrcode({
      // render method: 'canvas', 'image' or 'div'
      render: 'canvas',

      // version range somewhere in 1 .. 40
      minVersion: 1,
      maxVersion: 40,

      // error correction level: 'L', 'M', 'Q' or 'H'
      ecLevel: 'L',

      // offset in pixel if drawn onto existing canvas
      left: 0,
      top: 0,

      // size in pixel
      size: 250,

      // code color or image element
      fill: '#000',

      // background color or image element, null for transparent background
      //background: null,

      // content
      text: this.urlLandingPage,

      // corner radius relative to module width: 0.0 .. 0.5
      radius: 0,

      // quiet zone in modules
      quiet: 0,

      // modes
      // 0: normal
      // 1: label strip
      // 2: label box
      // 3: image strip
      // 4: image box
      mode: 0,

      mSize: 0.1,
      mPosX: 0.5,
      mPosY: 0.5,

      label: 'no label',
      fontname: 'sans',
      fontcolor: '#000',

      image: null
    });
  }

}
